import script from "./SideFile.vue?vue&type=script&setup=true&lang=js"
export * from "./SideFile.vue?vue&type=script&setup=true&lang=js"

import "./SideFile.vue?vue&type=style&index=0&id=1e205f78&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e205f78"]])

export default __exports__